module.exports = require('./lib/index').default;